import { cn } from '@/lib/utils';
import { Text } from '@/components/atoms/text';

export type FeaturesProps = {
  icon: React.ReactNode;
  title?: string;
};

export default function Features({ icon, title }: FeaturesProps) {
  const features = [
    { feature: '55M+ ethically-sourced IPs' },
    { feature: 'HTTP(S) & SOCKS5 support' },
    { feature: '<0.5s average response time' },
    { feature: '99.68% success rate' },
    { feature: 'Unlimited concurrent sessions' },
    { feature: 'Country, city & ZIP code targeting' },
    { feature: 'Rotating and sticky sessions' },
    { feature: '#1 IP quality in the market' },
    { feature: '24/7 tech support' },
  ];

  return (
    <div className='bg-neutral-N04 rounded-xl p-6'>
      <Text
        variant='subtitle-m'
        classNames={{ wrapper: 'flex justify-start pb-6' }}
      >
        {title}
      </Text>
      <div className={cn('m:grid m:grid-cols-3 m:gap-y-3 justify-start')}>
        {features.map(({ feature }, index) => (
          <div
            className='text-neutral-N99 text-body-m m:pb-0 flex items-center gap-2 pb-3'
            key={index}
          >
            <div className='flex max-h-5 min-h-5 min-w-5 max-w-5 items-center justify-center'>
              {icon}
            </div>
            <p className='mf-3'>{feature}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
